import { render, staticRenderFns } from "./JobTable.vue?vue&type=template&id=ce04848a&scoped=true"
import script from "./JobTable.vue?vue&type=script&lang=js"
export * from "./JobTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce04848a",
  null
  
)

export default component.exports